// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Account/components/CardBalance/CardBalance.css
// module id = 467
// module chunks = 0